import { Component, OnInit, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule } from '@angular/common';
import { ModalComponent } from "../../modal/modal.component";
import { InicioService } from '../../../services/inicio.service';
import { EjecucionService } from '../../../services/ejecucion.service';
import { ListarAsistenciaComponent } from "../listar-asistencia/listar-asistencia.component";
import { PlanEvaluacionComponent } from "../plan-evaluacion/plan-evaluacion.component";
import { NotasComponent } from "../notas/notas.component";

@Component({
  selector: 'app-acciones-formativas',
  standalone: true,
  imports: [CommonModule, ModalComponent, FormsModule, ListarAsistenciaComponent, PlanEvaluacionComponent, NotasComponent],
  templateUrl: './acciones-formativas.component.html',
  styleUrl: './acciones-formativas.component.css'
})
export class AccionesFormativasComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  years: number[] = [];
  selectedYear: number = 0;
  user: any;
  resultado: any = [];
  filteredResultado: any[] = []; // Nuevo array para los resultados filtrados
  errorMessage: string = '';
  searchTerm: string = ''; // Variable para almacenar el término de búsqueda

  isAsistencia: boolean = false;
  isPlanEvaluacion: boolean = false;
  isNotas: boolean = false;
  id_accion_formativa_env: string = '';
  anio_env: string = '';
  nombre_uc: string = '';
  pre_impreso: string = '';
  fechInicio: string = '';
  fechFin: string = '';
  idOferta: string = '';


  private srvLogin = inject(InicioService);
  private servicios = inject(EjecucionService);

  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
    this.getFullYear();
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.listarAccionFormativa(this.selectedYear.toString(), this.user.id_centro, this.user.id_institucional.toString()).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.resultado = rs.data;
        this.filteredResultado = [...this.resultado]; // Inicializa los resultados filtrados con todos los datos
        console.log(rs.data);
      },
      error: (error) => {
        this.errorMessage = error.message;
      },
    });
  }

  onChangeYear(event: any){
    //this.planificacion();
    //console.log(event.target.value)
    this.selectedYear = event.target.value;
    this.servicios.listarAccionFormativa(this.selectedYear.toString(), this.user.id_centro, this.user.id_institucional.toString()).subscribe({
      next: (rs) => {
        this.resultado = rs.data;
        this.filteredResultado = [...this.resultado]; // Actualiza los resultados filtrados al cambiar el año
      },
      error: (error) => {
        this.errorMessage = error.message;
      }
    });
  }

  getFullYear() {
    const year = new Date().getFullYear();
    this.selectedYear = year;
    this.years = [year - 1, year, year + 1];
  }

  // Método para filtrar la tabla
  buscarAccionFormativa() {
    this.filteredResultado = this.resultado.filter((item: any) => {
      const nombreOferta = item.nombre_oferta ? this.quitarAcentos(item.nombre_oferta.toLowerCase()) : '';
      const ucPreImpreso = item.uc_pre_impreso ? item.uc_pre_impreso.toLowerCase() : '';
      const nombreFacilitador = item.nombre_facilitador ? this.quitarAcentos(item.nombre_facilitador.toLowerCase()) : '';
      const term = this.searchTerm.toLowerCase();
      return (
        nombreOferta.includes(term) ||
        ucPreImpreso.includes(term) ||
        nombreFacilitador.includes(term)
      );
    });
  }

  quitarAcentos(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  listar_asistencia(id_accion_formativa: string, nombre: string, pre_impreso: string, fecha_inicio: string, fecha_fin: string){
    let ano = (document.getElementById('ano') as HTMLInputElement);
    console.log('aaaa:   ',nombre,'    rrrrrr:    ',pre_impreso);
    this.id_accion_formativa_env = id_accion_formativa;
    this.anio_env = ano.value;
    this.nombre_uc = nombre;
    this.pre_impreso = pre_impreso;
    this.fechInicio = fecha_inicio;
    this.fechFin = fecha_fin;
    this.isAsistencia = true;
  }

  plan_evaluacion(id_accion_formativa: string, id_oferta_formativa: string, nombre: string, pre_impreso: string){
    this.id_accion_formativa_env = id_accion_formativa;
    this.idOferta = id_oferta_formativa;
    this.nombre_uc = nombre;
    this.pre_impreso = pre_impreso;
    this.isPlanEvaluacion = true;
  }

  carga_notas(id_accion_formativa: string, nombre: string, pre_impreso: string){
    this.id_accion_formativa_env = id_accion_formativa;
    this.nombre_uc = nombre;
    this.pre_impreso = pre_impreso;
    this.isNotas = true;
  }

  volver(rsl: any) {
    this.isAsistencia = rsl.value;
    this.isPlanEvaluacion = rsl.value;
    this.isNotas = rsl.value;
    if(rsl.validador){
      this.titulo = '!EXITO¡';
      this.tipo_color = 'success';
      this.letra_color = 'light';
      this.mensaje = 'Petición realizada.';
      this.mdl.alerta();
    }

    if(rsl.warning == 1){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = "Cargue plan de evaluacion, antes de cargar notas!";
      this.mdl.alerta();
    }

    if(rsl.warning == 2){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = "Por favor realize unas incripciones para poder cargar asistencia!";
      this.mdl.alerta();
    }

  }

}
